import { ReactNode } from 'react';
import { IconFrequency } from '@/assets/icons/IconFrequency';
import { ChannelBadge } from '@/ui-components/molecules/ChannelCardStrip/ChannelBadge';
import styles from './onAirItem.module.scss';

const { mainWrapper, imageWrapper, metaDataWrapper, showNameStyles, contentWrapper, onAirTimeStyles, badgeStyles } =
    styles;

export interface OnAirItemProps {
    image: ReactNode;
    live: boolean;
    onAirTime: string;
    showName: string;
    badgeText?: string;
    showIcon?: boolean;
}

export function OnAirItem({
    image,
    live,
    onAirTime,
    showName,
    badgeText = 'ON AIR NOW',
    showIcon = true,
}: OnAirItemProps) {
    return (
        <div className={mainWrapper}>
            <div className={imageWrapper}>{image}</div>
            <div className={contentWrapper}>
                <div className={metaDataWrapper}>
                    {live && (
                        <>
                            <ChannelBadge badgeText={badgeText} className={badgeStyles} />
                            {showIcon && <IconFrequency />}
                            <div className={onAirTimeStyles}>{`${onAirTime}`} </div>
                        </>
                    )}
                </div>
                <div className={showNameStyles}>{showName}</div>
            </div>
        </div>
    );
}
